import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDeleteFilled = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M10 2.25C9.58579 2.25 9.25 2.58579 9.25 3C9.25 3.41421 9.58579 3.75 10 3.75H14C14.4142 3.75 14.75 3.41421 14.75 3C14.75 2.58579 14.4142 2.25 14 2.25H10ZM4.5 5.25C4.08579 5.25 3.75 5.58579 3.75 6C3.75 6.41421 4.08579 6.75 4.5 6.75H5.25V18.75C5.25 20.3989 6.56551 21.75 8.231 21.75H15.731C17.3788 21.75 18.75 20.4156 18.75 18.75V6.75H19.5C19.9142 6.75 20.25 6.41421 20.25 6C20.25 5.58579 19.9142 5.25 19.5 5.25H4.5ZM10.75 10C10.75 9.58579 10.4142 9.25 10 9.25C9.58579 9.25 9.25 9.58579 9.25 10V17C9.25 17.4142 9.58579 17.75 10 17.75C10.4142 17.75 10.75 17.4142 10.75 17V10ZM14.75 10C14.75 9.58579 14.4142 9.25 14 9.25C13.5858 9.25 13.25 9.58579 13.25 10V17C13.25 17.4142 13.5858 17.75 14 17.75C14.4142 17.75 14.75 17.4142 14.75 17V10Z",
		fill: "#111827"
	})
});
const ForwardRef = forwardRef(SvgDeleteFilled);
export default ForwardRef;
